<script lang="ts" setup>
import { watch } from "vue";
import * as errorBody from "../constants/ErrorBody";
import { useUserStore } from "../store/index";
import { useToast } from "../composables/useToast";

// initialize store
const userStore = useUserStore();
const { showToast } = useToast();

// Watch the error state and show a toast when an error occurs
watch(
  () => userStore.error.value,
  (isError) => {
    if (isError) {
      const message = userStore.error.message || "An unexpected error occurred";
      showToast(message, "error");
      // Reset the error state so it doesn't keep showing
      userStore.error.value = false;
    }
  },
);
</script>

<template>
  <!-- Errors are now shown as toast notifications via ToastNotification component -->
</template>
